import { debounce } from 'lodash';

import { buildSelectableStudentParent } from '@/utils/buildSelectable';

import { search } from '@/api/StudentParentApi';

import { Selectable } from '@/components/selectBox/selectBox';

export function useStudentParentsSearch(searchFilters?: Record<string, unknown>) {
  const searchQuery = ref('');
  const isLoading = ref(false);
  const studentParentOptions = ref<Selectable<number>[]>([]);
  const localSearchFilters = ref(searchFilters);

  const searchStudentParents = debounce(async (query: string) => {
    const response = await search({
      filters: {
        ...localSearchFilters.value,
        search: query
      }
    });

    studentParentOptions.value = response.map((parent) =>
      buildSelectableStudentParent(parent)
    ) as Selectable<number>[];

    isLoading.value = false;
  }, 300);

  function updateSearchFilters(searchFilters?: Record<string, unknown>) {
    localSearchFilters.value = searchFilters;
    searchStudentParents(searchQuery.value);
  }

  function onQueryChange(query: string): void {
    isLoading.value = true;
    searchQuery.value = query;

    searchStudentParents(query);
  }

  return {
    studentParentOptions,
    searchStudentParents,
    isLoading,
    onQueryChange,
    updateSearchFilters
  };
}
